import type { Product } from "@/data/products";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const MEASUREMENT_ID = (import.meta.env.VITE_GA_MEASUREMENT_ID || "").trim();

function getPagePath() {
  if (typeof window === "undefined") return "/";
  return `${window.location.pathname}${window.location.search}`;
}

export function isAnalyticsEnabled() {
  return Boolean(MEASUREMENT_ID);
}

export function initAnalytics() {
  if (typeof window === "undefined" || !MEASUREMENT_ID) {
    return;
  }

  if (window.gtag) {
    window.gtag("config", MEASUREMENT_ID, {
      page_path: getPagePath(),
    });
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer?.push(args);
  };

  window.gtag("js", new Date());
  window.gtag("config", MEASUREMENT_ID, {
    page_path: getPagePath(),
  });

  const existingScript = document.querySelector(
    `script[data-ga-measurement-id="${MEASUREMENT_ID}"]`,
  );
  if (existingScript) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  script.dataset.gaMeasurementId = MEASUREMENT_ID;
  document.head.appendChild(script);
}

export function trackPageView(pageTitle?: string) {
  if (!window.gtag || !MEASUREMENT_ID) {
    return;
  }

  window.gtag("event", "page_view", {
    page_title: pageTitle || document.title,
    page_location: window.location.href,
    page_path: getPagePath(),
  });
}

export function trackOfferClick(product: Product, placement: "card" | "detail") {
  if (!window.gtag || !MEASUREMENT_ID) {
    return;
  }

  window.gtag("event", "select_item", {
    item_list_name: placement,
    items: [
      {
        item_id: String(product.id),
        item_name: product.nome,
        item_category: product.categoria,
        item_brand: product.loja,
        price: product.precoAtual,
        discount: product.desconto,
      },
    ],
  });

  window.gtag("event", "click", {
    event_category: "affiliate",
    event_label: product.nome,
    value: product.precoAtual,
    placement,
    destination_url: product.linkAfiliado,
  });
}
